import React from 'react';
import PropTypes from 'prop-types';

const Angle4Path = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M5 6a3 3 0 0 0-3 3v14.001A3 3 0 0 0 5 26h14a3 3 0 0 0 3-2.999V9a3 3 0 0 0-3-3H5zm2 12l4.206-8H14v8h1.5v2H14v2.001h-2V20H7v-2zM30.882 7.629l-6.627 3.727a.503.503 0 0 0-.255.436v8.415a.5.5 0 0 0 .255.436l6.627 3.728A.75.75 0 0 0 32 23.718V8.283a.752.752 0 0 0-.751-.751.752.752 0 0 0-.367.097zM9.117 18H12v-5.582L9.117 18z"
    />
  );
};

Angle4Path.propTypes = {
  fill: PropTypes.string,
};

export default Angle4Path;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/angle-4.jsx